import { BActionIcon } from '@components/BActionIcon/BActionIcon';

export function AddDocumentMenu() {
  return (
    <>
      <BActionIcon icon="plus" size={42} variant="outline" />
    </>
  );
}
